export type SearchSortBy = 'created_at' | 'mostPopular' | 'mostRelevant' | 'bestSelling';
export const SEARCH_DEFAULT_SORT_BY = 'mostRelevant';

export interface SearchKeyword {
  keyword: string;
  filterId: string;
  value: string | boolean;
}

export interface SearchResponse {
  filters: SearchFilter[];
  query: string;
  parsedQuery: string;
  count: number;
  hits: number;
  offset: number;
  limit: number;
  products: SearchResultProduct[];
  pages: SearchResultPage[];
  categories: SearchResultCategory[];
  redirect?: string;
  fallbackContent?: string;
  previewMasks: PreviewMasks;
}

export interface ActiveFilters {
  [key: string]: (string | boolean)[];
}
export interface SearchFilter {
  id: string;
  name: string;
  facets: SearchFilterFacet[];
}

export interface SearchFilterFacet {
  type: string;
  name: string;
  value: string | boolean;
  count: number;
  checked?: boolean;
  icon?: string;
  subSections?: SearchFilterFacet[];
}

export interface SearchFilterColor {
  title: string;
  id: number;
  checked: boolean;
}

export interface SearchResultCategory {
  title: string;
  url: string;
  image?: string;
  categoryId: number;
  subTitle?: string;
}
export interface SearchResultPage {
  title: string;
  url: string;
  subTitle?: string;
}

export interface MaskImage {
  size: string;
  background: string;
  foregroundMask: string;
}

export interface ImageCoordinates {
  x0: number;
  y0: number;
  x1: number;
  y1: number;
}

export interface PreviewMask {
  type: string;
  id: string[];
  images: MaskImage[];
  imageCoordinates: ImageCoordinates;
}

export interface PreviewMasks {
  previewMask: PreviewMask[];
}

export interface SearchResultProduct {
  id: string;
  image: string;
  secondaryImage: string;
  categoryId: number;
  deepLink: string;
  name: string;
  productId: number;
  productTypeId: number;
  subTitle: string;
  url: string;
  productTier: string;
  sku: string;
  favourited: boolean;
  isPersonalised: boolean;
  productSource: string;
  isExternalAsset: boolean;
  encDesignId?: string;
}
export interface SearchState {
  isLoading: boolean;
  searchQuery: string;
  currentQuery: string;
  parsedQuery: string;
  previewMasks: PreviewMasks;
  showRetryModal: boolean;
  failedSearchRequestCount: number;
  results: {
    products: SearchResultProduct[];
  };
  filters: SearchFilter[];
  pageNr?: number;
  offset: number;
  showFilters: boolean;
  settings: {
    sortBy: SearchSortBy;
    filters: ActiveFilters;
    defaultFilters: ActiveFilters;
  };
  totalFetched: number;
  totalAvailable: number;
  refetchFlag: boolean;
  lastQueryStringHash: string;
  showFallbackLandingPage: boolean;
  searchSessionId: string;
  gtmProductsData: any;
}

export interface BreadCrumb {
  title: string;
  url?: string;
}
